// extracted by mini-css-extract-plugin
export var content = "confirmation-module--content--e7283";
export var icon = "confirmation-module--icon--c92d5";
export var wrapper = "confirmation-module--wrapper--2cbd0";